var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "simple-wizard",
          {
            attrs: {
              plain: "",
              "show-header": false,
              title: "Send Sms",
              "sub-title": "",
            },
            on: { stepChange: _vm.stepChange },
          },
          [
            _c(
              "wizard-tab",
              { attrs: { "before-change": _vm.validateDetails, id: "step1" } },
              [
                _c("template", { slot: "label" }, [
                  _vm._v(
                    "\n                    Create SMS Template\n                "
                  ),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "form-wrapper",
                      {
                        staticClass: "form-wrapper",
                        attrs: { validator: _vm.$v.form },
                      },
                      [
                        _c(
                          "form-group",
                          { staticClass: "custom-merge-field" },
                          [
                            _c(
                              "drop-down",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass: "dropdown-toggle md-info",
                                    attrs: {
                                      slot: "title",
                                      "data-toggle": "dropdown",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                    slot: "title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Insert Merge Field\n                                "
                                    ),
                                  ]
                                ),
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  _vm._l(_vm.mergeFields, function (event) {
                                    return _c("li", { key: event.key }, [
                                      event.key === "stopcustomfields"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "custom-field-header",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(event.name) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getSelectedMergeField(
                                                    event.key
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(event.name))]
                                          ),
                                    ])
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "form-group",
                          {
                            staticClass: "custom-textarea",
                            attrs: { name: "template" },
                          },
                          [
                            _c("md-textarea", {
                              ref: "template",
                              model: {
                                value: _vm.form.template,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "template", $$v)
                                },
                                expression: "form.template",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "wizard-tab",
              { attrs: { "before-change": _vm.validateDetails, id: "step2" } },
              [
                _c("template", { slot: "label" }, [
                  _vm._v(
                    "\n                    Confirmation\n                "
                  ),
                ]),
                _c("div", { staticClass: "confirmation-message" }, [
                  _vm._v(
                    "\n                    Are you sure you want to send SMSs to " +
                      _vm._s(_vm.orderContact.phone) +
                      "?\n                    "
                  ),
                  _c("br"),
                  _vm._v(
                    '\n                    Click the "Finish" button to send.\n                '
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }